import { API_BASE_URL } from '../config';

export async function fetchProfessionalSummary(token) {
  if (!token) {
    return {
      isProfessional: false,
      professionalType: null,
      panelPath: null,
      activeClientCount: 0,
      activeClients: [],
    };
  }

  const headers = { Authorization: `Bearer ${token}` };

  const profileRes = await fetch(`${API_BASE_URL}/api/professional/profile`, {
    credentials: 'include',
    headers,
  });

  if (!profileRes.ok) {
    return {
      isProfessional: false,
      professionalType: null,
      panelPath: null,
      activeClientCount: 0,
      activeClients: [],
    };
  }

  const profileData = await profileRes.json().catch(() => ({}));
  const profile = profileData?.profile;
  const professionalType = profile?.professionalType || null;
  const isProfessional = Boolean(profileData?.exists && professionalType);

  if (!isProfessional) {
    return {
      isProfessional: false,
      professionalType: null,
      panelPath: null,
      activeClientCount: 0,
      activeClients: [],
    };
  }

  const panelPath = professionalType === 'pt' ? '/pt-panel' : '/diyetisyen-panel';

  const invitesRes = await fetch(`${API_BASE_URL}/api/professional/invites`, {
    credentials: 'include',
    headers,
  });

  const invitesData = invitesRes.ok ? await invitesRes.json().catch(() => ({})) : {};
  const invites = Array.isArray(invitesData?.items) ? invitesData.items : [];

  const activeClients = invites
    .map((invite) => {
      const rel = Array.isArray(invite?.relationships)
        ? invite.relationships.find((r) => String(r?.status || '').toLowerCase() === 'active')
        : null;
      if (!rel) return null;
      return {
        id: rel.clientUserId,
        name: invite?.targetUser?.name || invite?.targetUser?.email || `Kullanıcı #${rel.clientUserId}`,
      };
    })
    .filter(Boolean);

  return {
    isProfessional: true,
    professionalType,
    panelPath,
    activeClientCount: activeClients.length,
    activeClients: activeClients.slice(0, 5),
  };
}
